import React from "react";

import {
    Container,
    Row,
    Col,
    Button,
    ListGroup,
    ListGroupItem,
} from "react-bootstrap";

const Usuario = () => {
    return (
        <Container>
            <br />
            <br />
            <Row>
                <div className="col">
                    <br />
                    <bcolr />
                    <h3>
                        Configuración de archivos de configuración de staff,
                        contractor, budget y variables{" "}
                    </h3>
                    <p>
                        {" "}
                        Se ingresa archivos de carga de periodo para cada Nivel
                        de Variable{" "}
                    </p>

                    <div className="row">
                        <p className="text-danger">Vigente</p>
                    </div>
                    <div className="mb-3">
                        <label
                            for="formFileSm"
                            className="form-label text-danger"
                        ></label>
                        <input
                            className="form-control form-control-sm"
                            id="formFileSm"
                            type="file"
                        />
                    </div>

                    <div className="row">
                        <p className="text-danger">Egresos</p>
                    </div>
                    <div className="mb-3">
                        <label
                            for="formFileSm"
                            className="form-label text-danger"
                        ></label>
                        <input
                            className="form-control form-control-sm"
                            id="formFileSm"
                            type="file"
                        />
                    </div>

                    <div className="row">
                        <p className="text-danger">Absentismo</p>
                    </div>
                    <div className="mb-3">
                        <label
                            for="formFileSm"
                            className="form-label text-danger"
                        ></label>
                        <input
                            className="form-control form-control-sm"
                            id="formFileSm"
                            type="file"
                        />
                    </div>

                    <div className="row">
                        <p className="text-danger">Contractor Agregado</p>
                    </div>
                    <div className="mb-3">
                        <label
                            for="formFileSm"
                            className="form-label text-danger"
                        ></label>
                        <input
                            className="form-control form-control-sm"
                            id="formFileSm"
                            type="file"
                        />
                    </div>

                    <div className="row">
                        <p className="text-danger">
                            Subir Archivo EXCEL Budget 2022 Exhibit 19 Staff, se
                            sube anualmente
                        </p>
                    </div>
                    <div className="mb-3">
                        <label
                            for="formFileSm"
                            className="form-label text-danger"
                        ></label>
                        <input
                            className="form-control form-control-sm"
                            id="formFileSm"
                            type="file"
                        />
                    </div>

                    <div className="row">
                        <p className="text-danger">
                            Subir Archivo EXCEL Budget 2022 Exhibit 20
                            Contractor, , se sube anualmente
                        </p>
                    </div>
                    <div className="mb-3">
                        <label
                            for="formFileSm"
                            className="form-label text-danger"
                        ></label>
                        <input
                            className="form-control form-control-sm"
                            id="formFileSm"
                            type="file"
                        />
                    </div>

                    <div className="row">
                        <p className="text-danger">
                            Subir Archivo EXCEL Variables y Sub Variables, se
                            sube anualmente
                        </p>
                    </div>
                    <div className="mb-3">
                        <label
                            for="formFileSm"
                            className="form-label text-danger"
                        ></label>
                        <input
                            className="form-control form-control-sm"
                            id="formFileSm"
                            type="file"
                        />
                    </div>
                    <br />
                    <br />
                    <br />
                    <br />
                    <div className="row">
                        <div className="d-grid gap-2 col-4 ">
                            <button className="btn btn-primary" type="button">
                                Subir archivos a plataforma y Procesar {"     "}
                            </button>
                            <button
                                className="btn btn-secondary btn-sm"
                                type="button"
                            >
                                Consultar cargar anteriores {"     "}
                            </button>
                        </div>
                    </div>
                    <br />
                    <br />
                </div>
            </Row>
        </Container>
    );
};

export default Usuario;
